import { useState } from "react";

export const useLoadingIds = () => {
  const [loadingIds, setLoadingIds] = useState<Set<number>>(new Set());

  const setLoadingId = (id: number) => {
    setLoadingIds(new Set(loadingIds).add(id));
  };

  const unsetLoadingId = (id: number) => {
    const newSet = new Set(loadingIds);

    newSet.delete(id);
    setLoadingIds(newSet);
  };

  const getLoadingStatusById = (id: number) => {
    return loadingIds.has(id);
  };

  return {
    getLoadingStatusById,
    unsetLoadingId,
    setLoadingId,
  };
};
